import { createAction } from 'redux-actions'
import { CREATE_ACCOUNT, UPDATE_ACCOUNT, UPDATE_PASSWORD } from './constants'
import { createAccountApi, updateUserInfoApi, updateUserPasswordApi, updateSuperAdminInfoApi } from './api'

export const createAccountAction = createAction(CREATE_ACCOUNT, async (data) => createAccountApi(data))
export const updateUserAction = createAction(UPDATE_ACCOUNT, async (id, data) => updateUserInfoApi(id, data))
export const updateAdminAction = createAction(UPDATE_ACCOUNT, async (id, data) => updateSuperAdminInfoApi(id, data))
export const updatePasswordAction = createAction(UPDATE_PASSWORD, async (data) => updateUserPasswordApi(data))
